import { AppThunkDispatch } from '@Reducers/index';

import { IUserExtension } from '@ClientModels/userExtension';

export const SET_SELECTED_USER = 'SET_SELECTED_USER';
export const CLEAR_SELECTED_USER = 'CLEAR_SELECTED_USER';

export class SetSelectedUser {
  readonly type = SET_SELECTED_USER;

  constructor(public payload: IUserExtension | null) {}
}

export class ClearSelectedUser {
  readonly type = CLEAR_SELECTED_USER;
}

export type PeopleActions = SetSelectedUser | ClearSelectedUser;

export const setSelectedUser = (user: IUserExtension | null) => (dispatch: AppThunkDispatch) => {
  dispatch(new SetSelectedUser(user));
};

export const clearSelectedUser = () => (dispatch: AppThunkDispatch) => {
  dispatch(new ClearSelectedUser());
};
